import React, { useState, useEffect } from "react";
import { Checkbox, FormControlLabel } from "@material-ui/core";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { FormattedMessage, injectIntl } from "react-intl";
import * as auth from "../_redux/authRedux";
import { login } from "../_redux/authCrud";

/*
  INTL (i18n) docs:
  https://github.com/formatjs/react-intl/blob/master/docs/Components.md#formattedmessage
*/

/*
  Formik+YUP:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
*/

const initialValues = {
  email: "admin@brainary.io",
  password: "123456",
};

function handleClick() {
  this.props.history.push("/");
}

function Login(props) {
  const { intl } = props;
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const LoginSchema = Yup.object().shape({
    email: Yup.string()
      // .email("Wrong email format")
      .min(3, "Minimum 3 symbols")
      .max(50, "Maximum 50 symbols"),
    // .required(
    //   intl.formatMessage({
    //     id: "필수 항목입니다." // "AUTH.VALIDATION.REQUIRED_FIELD"
    //   })
    // )
    password: Yup.string()
      .min(3, "Minimum 3 symbols")
      .max(50, "Maximum 50 symbols")
    // .required(
    //   intl.formatMessage({
    //     id: "필수 항목입니다."  // "AUTH.VALIDATION.REQUIRED_FIELD"
    //   })
    // )
  });

  const enableLoading = () => {
    setLoading(true);
  };

  const disableLoading = () => {
    setLoading(false);
  };

  const getInputClasses = fieldname => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };

  const [autoLogin, setAutoLogin] = useState(false);
  const [saveEmail, setSaveEmail] = useState(false);

  const formik = useFormik({
    initialValues,
    validationSchema: LoginSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {


      
      localStorage.setItem("TOKEN", 'adminZimbraToken');
      sessionStorage.setItem('adminZimbraToken', 'adminZimbraToken');

      props.login('adminZimbraToken');

      // enableLoading();
      // setTimeout(() => {

      //   login(values.email, values.password)
      //     // .then(({ data: { accessToken } }) => {
      //     .then(result => {
      //       console.log("Login Result", result.data);

      //       localStorage.setItem("TOKEN", result.data.adminZimbraToken);
      //       disableLoading();
      //       sessionStorage.setItem('adminZimbraToken', result.data.adminZimbraToken);

      //       props.login(result.data.adminZimbraToken);
      //     })
      //     .catch(err => {
      //       console.log(err);
      //       disableLoading();
      //       setSubmitting(false);
      //       setStatus(
      //         intl.formatMessage({
      //           id: "AUTH.VALIDATION.INVALID_LOGIN"
      //         })
      //       );
      //     });
      // }, 100);
    }
  });

  useEffect(() => {
    // formik.handleSubmit();
  }, []);


  return (
    <div className="login-form login-signin" id="kt_login_signin_form">
      {/* begin::Head */}
      <div className="text-center mb-10 mb-lg-20">
        <img
          src={"/media/bizbee.png"}
          width="64"
          // height="136" 
          alt="logo"
        />
        <br></br>
        <br></br>
        <h4 className=""
        style={{
          fontSize: 24,
          fontWeight: 900
        }}>
          비즈비 메일 관리자 로그인
        </h4>

        {/* <img
          src={"/media/images/admin.png"}
          width="70"
          height="20"
          alt="logo"
        /> */}
      </div>
      {/* end::Head */}

      {/*begin::Form*/}
      <form
        onSubmit={formik.handleSubmit}
        className="form fv-plugins-bootstrap fv-plugins-framework"
      >
        {/* {formik.status ? (
          <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
            <div className="alert-text font-weight-bold">{formik.status}</div>
          </div>
        ) : (
          <div className="mb-10 alert alert-custom alert-light-info alert-dismissible">
            <div className="alert-text " 
                  style={{
                    textAlign: 'center'
                  }}>
              사용자 <strong>아이디</strong>와 <strong>비밀번호</strong>를 입력하세요.
            </div>
          </div>
        )} */}

        <div className="form-group fv-plugins-icon-container">
          <input
            placeholder="아이디 (이메일)"
            type="text"
            className={`form-control form-control-solid h-auto `}
            // ${getInputClasses("email")}
            style={{
              borderColor: "lightgray"
            }}
            name="email"
            {...formik.getFieldProps("email")}
          />
          {formik.touched.email && formik.errors.email ? (
            <div className="fv-plugins-message-container">
              <div className="fv-help-block">{formik.errors.email}</div>
            </div>
          ) : null}
        </div>
        <div className="form-group fv-plugins-icon-container">
          <input
            placeholder="비밀번호"
            type="password"
            className={`form-control form-control-solid h-auto `}
            // ${getInputClasses("password")}
            style={{ 
              borderColor: "lightgray"
            }}
            name="password"
            {...formik.getFieldProps("password")}
          />
          {formik.touched.password && formik.errors.password ? (
            <div className="fv-plugins-message-container">
              <div className="fv-help-block">{formik.errors.password}</div>
            </div>
          ) : null}
        </div>
        <div
          className="form-group d-flex flex-wrap justify-content-between align-items-center"
          style={{ "marginBottom": "4px" }}
        >
          {/*}
          <Link
            to="/auth/forgot-password"
            className="text-dark-50 text-hover-primary my-3 mr-2"
            id="kt_login_forgot"
          >
            <FormattedMessage id="AUTH.GENERAL.FORGOT_BUTTON" />
          </Link>
          */}

          <button
            id="kt_login_signin_submit"
            type="submit"
            // onClick={handleSignIn}
            disabled={formik.isSubmitting}
            className={`btn`}
            style={{
              border: "none",
              width: "100%",
              height: "42px",
              margin: "auto",
              color: "white",
              background: "#123456",
              fontSize: "1.143rem",
              fontWeight: "bold"
            }}
          >
            <span>로그인</span>
            {loading && <span className="ml-3 spinner spinner-white"></span>}
          </button>
        </div>
        <div style={{ height: "24px" }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={autoLogin}
                onChange={(e) => { setAutoLogin(!autoLogin)}}
                value="true"
                inputProps={{
                  "aria-label": "primary checkbox",
                }}
              />
            }
            label="자동 로그인"
          />
        </div>
        <div>
          <FormControlLabel
            control={
              <Checkbox
              checked={saveEmail}
              onChange={(e) => { setSaveEmail(!saveEmail)}}
                value="true"
                inputProps={{
                  "aria-label": "primary checkbox"
                }}
              />
            }
            label="아이디 저장"
          />
        </div>

        <div
          className="form-group d-flex flex-wrap justify-content-between align-items-center"
          style={{ "marginBottom": "4px" }}
        >
          {/*}
          <Link
            to="/auth/forgot-password"
            className="text-dark-50 text-hover-primary my-3 mr-2"
            id="kt_login_forgot"
          >
            <FormattedMessage id="AUTH.GENERAL.FORGOT_BUTTON" />
          </Link>
          */}
          {/* <Link
            to="/auth/forgot-password"
            className="text-dark-50 "
            id="kt_login_forgot"
            style={{ width: "100%", fontSize: "1.2rem" }}
          >
            <div
              className="alert-text "
              style={{
                textAlign: "center",
                marginTop: "2rem",
                marginBottom: "2rem"
              }}
            >
              <strong>아이디</strong> / <strong>비밀번호</strong> 찾기
            </div>
          </Link> */}

          {/* <button
            id="kt_login_signin_submit"
            type="submit"
            // onClick={handleSignIn}
            disabled={formik.isSubmitting}
            className={`btn `}
            style={{
              width: "100%",
              height: "42px",
              margin: "auto",
              fontSize: "1.143rem",
              color: "#123456",
              fontWeight: "bold",
              background: "transparent",
              border: "1px solid lightgray"
            }}
          >
            <span>서비스 계정 가입</span>
          </button> */}
        </div>
      </form>
      {/*end::Form*/}
    </div>
  );
}

export default injectIntl(connect(null, auth.actions)(Login));
